/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchPreviewRequest
 */
export interface MdmMatchPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRequest
     */
    entityType: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRequest
     */
    entityId1: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRequest
     */
    entityId2: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewRequest
     */
    policyConfigurationId?: string;
}

/**
 * Check if a given object implements the MdmMatchPreviewRequest interface.
 */
export function instanceOfMdmMatchPreviewRequest(value: object): value is MdmMatchPreviewRequest {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId1' in value) || value['entityId1'] === undefined) return false;
    if (!('entityId2' in value) || value['entityId2'] === undefined) return false;
    return true;
}

export function MdmMatchPreviewRequestFromJSON(json: any): MdmMatchPreviewRequest {
    return MdmMatchPreviewRequestFromJSONTyped(json, false);
}

export function MdmMatchPreviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'],
        'entityId1': json['entityId1'],
        'entityId2': json['entityId2'],
        'policyConfigurationId': json['policyConfigurationId'] == null ? undefined : json['policyConfigurationId'],
    };
}

export function MdmMatchPreviewRequestToJSON(json: any): MdmMatchPreviewRequest {
    return MdmMatchPreviewRequestToJSONTyped(json, false);
}

export function MdmMatchPreviewRequestToJSONTyped(value?: MdmMatchPreviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId1': value['entityId1'],
        'entityId2': value['entityId2'],
        'policyConfigurationId': value['policyConfigurationId'],
    };
}

